import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import moment from 'moment';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import icon from 'src/assets/images/appointment-view-calander-icon.png';
import PrimaryBtn from './primaryBtn';
import { IHomecareAppointDetail } from 'src/types/GlobalInterfaces';

interface IProps {
    bool: boolean;
    appointmentId: string;
    userRole: "customer" | "admin"
    setMainData: Dispatch<SetStateAction<IHomecareAppointDetail | null>>;
    onChangeStatus: () => void;
};

interface IObj {
    _id: string;
    orderId: string;
    time: string;
    appointmentDate: string;
    daySlot: string;
    reason: string;
    createdAt: string;
    firstName: string;
    lastName: "",
};

const HomecareAppointmentRequest: React.FC<IProps> = ({
    bool = false,
    appointmentId = "",
    userRole = "customer",
    setMainData = () => { },
    onChangeStatus = () => { },
}) => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IObj | null>();

    const [actionType, setActionType] = useState<null | "accept" | "decline">(null);
    const actionPerform = async (type: "accept" | "decline") => {
        setActionType(type);
        const { res, err } = await httpRequest<{ data: string; time: string; date: string; daySlot: "morning" | "afternoon" | "evening" | "night" }>({
            method: "put",
            path: `/home-care-order/appointment/request/status/${appointmentId}?status=${type}`,
            params: {}
        });
        if (res) {
            if (type === "accept") {
                setMainData(prev => prev ? { ...prev, reschedule: false, timeslot: res?.time, appointmentDate: res?.date, daySlot: res?.daySlot } : null);
            } else {
                setMainData(prev => prev ? { ...prev, reschedule: false } : null);
            }
            onChangeStatus();
            toast(res?.data || "Success!", { type: "success" });
        } else {
            toast(err, { type: "error" });
        }
        setActionType(null);
    };

    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<{ data: IObj | null }>({ path: `/home-care-order/appointment/request/${appointmentId}` });
        if (res) {
            setData(res?.data || null);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };

    useEffect(() => {
        if (appointmentId) {
            fetch();
        }
    }, [bool, appointmentId]);
    return (
        <>
            {isLoader ?
                <div className="text-center mt-5">
                    <CircularProgress size={20} style={{ color: "#004540" }} />
                </div>
                : data ?
                    <div className="pt-6">
                        <div className="flex items-center justify-center">
                            <p className="font-Poppins-SemiBold font-size-15px theme-color-green">
                                {moment(data?.createdAt).format("ddd D MMM")}
                            </p>
                        </div>
                        <div className="grid grid-cols-[.5fr_9.5fr] gap-[20px] mt-2">
                            <div className='relative z-10 flex items-center justify-center'>
                                <div className="flex items-center justify-center rounded-full bg-[#00443F] self-start w-[40px] h-[40px] mt-3 relative z-20">
                                    <img src={icon} alt="calander-icon" />
                                </div>
                            </div>
                            <div className='p-4 border-[2px] border-[#00443F] rounded-[13px] '>
                                <div className="flex gap-2 items-center justify-between">
                                    <div>
                                        <div className='flex gap-2 items-center'>
                                            <p className="font-Poppins-SemiBold font-size-15px capitalize">
                                                {`${data?.firstName || ""} ${data?.lastName || ""}`}
                                            </p>
                                        </div>
                                        <p className="font-Poppins-Regular font-size-15px">
                                            {`wants to reshedule this appointment at ${moment(data?.appointmentDate)?.format("DD-MM-YYYY")} ${data?.time || ""}`}
                                        </p>
                                    </div>
                                    <p className="font-Poppins-Regular font-size-15px ml-1">
                                        {moment(data?.createdAt).format("h:mm A")}
                                    </p>
                                </div>
                                <div className="my-3 flex justify-between">
                                    <p className="font-Poppins-Regular font-size-15px">
                                        {data?.reason || ""}
                                    </p>
                                    <div className='flex gap-2 items-center'>
                                        {userRole === "admin" &&
                                            <>
                                                <PrimaryBtn
                                                    loader={actionType === "accept"}
                                                    type="button"
                                                    ButtonText='Approve'
                                                    onPress={() => actionPerform("accept")}
                                                    btnExtraStyle={{
                                                        borderRadius: "100rem",
                                                        padding: '5px 25px',
                                                        backgroundColor: "#004540",
                                                        fontSize: '10px'
                                                    }}
                                                />
                                                <PrimaryBtn
                                                    loader={actionType === "decline"}
                                                    type="button"
                                                    ButtonText='Decline'
                                                    onPress={() => actionPerform("decline")}
                                                    btnExtraStyle={{
                                                        borderRadius: "100rem",
                                                        padding: '5px 25px',
                                                        backgroundColor: "#DF0000",
                                                        fontSize: '10px'
                                                    }}
                                                />
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <p className="pt-6">No Request</p>
                    </div>
            }
        </>
    );
};

export default HomecareAppointmentRequest;